import React, { useState } from "react";
import { FaUserMd, FaMinus, FaPlus, FaFileMedical, FaHeartbeat, FaHospitalUser, FaNotesMedical, FaStethoscope, FaCalendarCheck, FaPrescriptionBottleAlt, FaBriefcaseMedical, FaProcedures, FaHandHoldingMedical, FaBrain, FaLungs, FaCapsules, FaDna, FaEye, FaMicroscope, FaBone, FaChild, FaWheelchair, FaHospital, FaUserShield, FaAmbulance, FaLaptopMedical } from "react-icons/fa";
import Medpalm from "../../../assests/Healthcareprovider/special.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
const services = [
    {
        "icon": "<FaHeartbeat className='text-[#2a627a] text-lg' />",
        "title": "Cardiology",
        "description": "Comprehensive cardiovascular care focusing on the prevention, diagnosis, and treatment of heart and vascular diseases. Specializes in conditions such as coronary artery disease, heart failure, arrhythmias, and hypertension. Advanced diagnostic and interventional procedures include stress tests, echocardiograms, cardiac catheterization, angioplasty, and heart rhythm management through pacemakers and defibrillators."
    },
    {
        "icon": "<FaLungs className='text-[#2a627a] text-lg' />",
        "title": "Pulmonology",
        "description": "Expert care for lung and respiratory disorders, including asthma, chronic obstructive pulmonary disease (COPD), pneumonia, tuberculosis, lung infections, and interstitial lung disease. Pulmonary services include pulmonary function tests (PFTs), bronchoscopy, sleep apnea evaluation, and advanced respiratory therapy to enhance lung function and breathing capacity."
    },
    {
        "icon": "<FaBrain className='text-[#2a627a] text-lg' />",
        "title": "Neurology",
        "description": "Specialized diagnosis and treatment of conditions affecting the brain, spinal cord, and nervous system, including stroke, epilepsy, Parkinson’s disease, Alzheimer’s, multiple sclerosis, migraines, and neuropathies. Neurological assessments involve EEGs, MRI and CT scans, nerve conduction studies, and neurorehabilitation programs to enhance recovery and cognitive function."
    },
    {
        "icon": "<FaChild className='text-[#2a627a] text-lg' />",
        "title": "Pediatrics",
        "description": "Comprehensive healthcare for infants, children, and adolescents, covering preventive care, developmental screenings, vaccinations, and treatment of childhood illnesses such as infections, allergies, asthma, and congenital conditions. Pediatricians provide well-child visits, growth monitoring, nutrition counseling, and emergency care for acute pediatric conditions."
    },
    {
        "icon": "<FaWheelchair className='text-[#2a627a] text-lg' />",
        "title": "Physical Rehabilitation",
        "description": "Customized rehabilitation programs to restore movement, function, and independence for patients recovering from injuries, surgeries, strokes, spinal cord injuries, and musculoskeletal disorders. Services include physical therapy, occupational therapy, speech therapy, prosthetic training, and chronic pain management to improve mobility and quality of life."
    },
    {
        "icon": "<FaBone className='text-[#2a627a] text-lg' />",
        "title": "Orthopedics",
        "description": "Comprehensive orthopedic care for bone, joint, muscle, and ligament disorders, including fractures, arthritis, osteoporosis, tendonitis, and sports injuries. Offers non-surgical treatments, physical therapy, pain management, and surgical interventions such as joint replacements, arthroscopy, and spinal surgeries to restore mobility and function."
    },
    {
        "icon": "<FaMicroscope className='text-[#2a627a] text-lg' />",
        "title": "Oncology",
        "description": "Advanced cancer care, including early detection, diagnosis, and treatment with chemotherapy, radiation therapy, immunotherapy, targeted therapy, and surgical oncology. Specialized in managing various cancer types, offering personalized treatment plans, genetic testing, clinical trials, and palliative care to improve patient outcomes and quality of life."
    },
    {
        "icon": "<FaDna className='text-[#2a627a] text-lg' />",
        "title": "Genetic & Personalized Medicine",
        "description": "Cutting-edge medical services that customize treatments based on a patient’s genetic profile, helping predict disease risks and tailor medication plans. Applications include cancer genomics, rare disease identification, pharmacogenomics, and gene therapy research to develop highly targeted and effective treatment strategies."
    },
    {
        "icon": "<FaEye className='text-[#2a627a] text-lg' />",
        "title": "Ophthalmology",
        "description": "Comprehensive eye care services, including vision correction, cataract surgery, glaucoma management, diabetic retinopathy treatment, and macular degeneration care. Offers LASIK and refractive surgery, routine eye exams, and specialized interventions to preserve and restore eyesight."
    },
    {
        "icon": "<FaBrain className='text-[#2a627a] text-lg' />",
        "title": "Otolaryngology (ENT)",
        "description": "Expert treatment for disorders affecting the ear, nose, and throat, including sinus infections, hearing loss, vertigo, throat disorders, snoring, sleep apnea, and vocal cord conditions. ENT services also include allergy testing, audiology evaluations, and minimally invasive sinus and head & neck surgeries."
    },
    {
        "icon": "<FaCapsules className='text-[#2a627a] text-lg' />",
        "title": "Pharmacology",
        "description": "Comprehensive medication management services, including drug safety monitoring, dosage optimization, adverse reaction assessments, and research on new pharmaceutical treatments. Focuses on precision medicine, ensuring the safe and effective use of medications for chronic diseases, infections, and mental health conditions."
    },
    {
        "icon": "<FaHandHoldingMedical className='text-[#2a627a] text-lg' />",
        "title": "Palliative & Hospice Care",
        "description": "Compassionate, patient-centered care for individuals with serious, chronic, or terminal illnesses. Focuses on pain management, symptom relief, emotional support, and coordinated care to enhance comfort and dignity. Services extend to family counseling, spiritual support, and hospice care to ensure a holistic approach to end-of-life care."
    }
]

const features = [
    { icon: <FaStethoscope className="text-[#2a627a] text-lg" />, text: "Expert diagnosis and treatment for complex medical conditions." },
    { icon: <FaProcedures className="text-[#2a627a] text-lg" />, text: "Advanced surgical and non-surgical interventions tailored to patient needs." },
    { icon: <FaHandHoldingMedical className="text-[#2a627a] text-lg" />, text: "Improved quality of life through targeted therapies and rehabilitation." },
    { icon: <FaBrain className="text-[#2a627a] text-lg" />, text: "Personalized medicine approaches using genetic and molecular diagnostics." },
    { icon: <FaLungs className="text-[#2a627a] text-lg" />, text: "Early detection and prevention strategies for high-risk conditions." },
    { icon: <FaCapsules className="text-[#2a627a] text-lg" />, text: "Integration with telemedicine for remote consultations and follow-ups." }
];

const benefits = [
    { icon: <FaHospitalUser className="text-[#2a627a] text-lg" />, text: "Improves patient health with continuous monitoring and follow-ups." },
    { icon: <FaHeartbeat className="text-[#2a627a] text-lg" />, text: "Early detection of diseases through routine screenings." },
    { icon: <FaNotesMedical className="text-[#2a627a] text-lg" />, text: "Enhances coordination between primary care and specialists." },
    { icon: <FaBriefcaseMedical className="text-[#2a627a] text-lg" />, text: "Reduces emergency visits by managing health proactively." },
    { icon: <FaFileMedical className="text-[#2a627a] text-lg" />, text: "Streamlines medical history management through digital records." },
    { icon: <FaCalendarCheck className="text-[#2a627a] text-lg" />, text: "Encourages regular check-ups for lifelong well-being." }
    , {
        icon: <FaHeartbeat className="text-[#2a627a] text-lg" />,
        text: "Proactive disease management with AI-powered health monitoring."
    },
    {
        icon: <FaHospital className="text-[#2a627a] text-lg" />,
        text: "Reduces hospital readmissions through better outpatient follow-ups."
    },
    {
        icon: <FaPrescriptionBottleAlt className="text-[#2a627a] text-lg" />,
        text: "Efficient medication management with e-prescriptions and drug interaction alerts."
    },
    {
        icon: <FaUserShield className="text-[#2a627a] text-lg" />,
        text: "Enhanced patient safety with data encryption and HIPAA-compliant security."
    },
    {
        icon: <FaAmbulance className="text-[#2a627a] text-lg" />,
        text: "Faster emergency response coordination through real-time patient tracking."
    }
];
const cmsFeatures = [
    {
        icon: <FaUserMd className="text-[#2a627a] text-lg" />,
        role: "Primary Care Physician",
        text: "The main healthcare provider for routine checkups, chronic disease management, and preventive care. Works closely with specialists to coordinate patient treatments."
    },
    {
        icon: <FaBriefcaseMedical className="text-[#2a627a] text-lg" />,
        role: "Nurse Practitioner",
        text: "Provides advanced nursing care, including diagnosis, treatment, and patient education. Can prescribe medications and perform minor procedures."
    },
    {
        icon: <FaStethoscope className="text-[#2a627a] text-lg" />,
        role: "Physician Assistant",
        text: "Conducts medical exams, diagnoses illnesses, and assists in surgeries under the supervision of a physician."
    },
    {
        icon: <FaNotesMedical className="text-[#2a627a] text-lg" />,
        role: "Medical Assistant",
        text: "Supports doctors and nurses by managing administrative tasks, taking patient vitals, and preparing exam rooms."
    },
    {
        icon: <FaFileMedical className="text-[#2a627a] text-lg" />,
        role: "Care Coordinator",
        text: "Facilitates patient referrals, schedules follow-ups, and ensures smooth communication between departments."
    },
    {
        icon: <FaPrescriptionBottleAlt className="text-[#2a627a] text-lg" />,
        role: "Pharmacist",
        text: "Dispenses medications, educates patients on proper usage, and advises on potential drug interactions."
    },
    {
        icon: <FaAmbulance className="text-[#2a627a] text-lg" />,
        role: "Emergency Medical Technician (EMT)",
        text: "Provides life-saving emergency medical care and transport to healthcare facilities."
    },
    {
        icon: <FaHospital className="text-[#2a627a] text-lg" />,
        role: "Hospital Administrator",
        text: "Manages hospital operations, budget planning, and staff coordination to ensure smooth healthcare delivery."
    },
    {
        icon: <FaLaptopMedical className="text-[#2a627a] text-lg" />,
        role: "Health IT Specialist",
        text: "Manages healthcare technology systems, including EHR integration and cybersecurity measures."
    }
];

const SpecializedCare = () => {
    const [openIndex, setOpenIndex] = useState(0);
    return (
        <>
            <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
                {/* <div className="min-h-screen mt-10 p-8 bg-gradient-to-t from-[#78ffa5] to-[#03ab3b] w-full flex flex-col items-center shadow-lg rounded-lg"> */}
                {/* Header Section */}
                <div className=" text-center w-full">
                    <h1 className="font-semibold text-[30px] bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800  justify-center items-center flex">Specialized Care  - <span className="text-gray-800">HIKEHEALTH GS</span> </h1>
                    <p className="text-gray-800 mt-3 text-sm">
                        "Providing patient-centered, evidence-based, and technology-driven treatments for optimal health outcomes."
                    </p>
                </div>

                {/* What is Blue Button 2.0? */}
                <section className="mt-8 flex flex-col md:flex-row  bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
                    <img draggable={false}src={Medpalm} alt="Healthcare Tech" className="rounded-lg shadow-xl  w-full md:w-1/5" />
                    <div className="md:ml-6 mt-2 md:mt-0">
                        <h2 className="text-[30px] font-extrabold text-[#2a627a]"> What is Specialized Care ?</h2>
                        <p className="text-gray-800 mt-2 text-sm text-wrap">
                            Specialized care focuses on advanced medical treatment for specific conditions, such as cardiology, oncology, neurology, and orthopedics. It involves expert consultations, cutting-edge procedures, and personalized care plans.

                            At HIKEHEALTH GS, we enhance specialized care with digital health solutions, improving precision, efficiency, and patient outcomes.
                        </p>
                    </div>
                </section>

                {/* Role in AI&Machine */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Role in Specialized Care
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {cmsFeatures.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <span className="text-gray-800 text-sm font-medium">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Key Features Section */}
                <section className="mt-6 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Key Features
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {features.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                whileInView={{ opacity: 1, x: 0 }} // Move to center
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>


                {/* Benefits Section */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                        Benefits
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {benefits.map((item, index) => (
                            <motion.div key={index} className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow" initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}>

                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>




                {/* Services Section */}
                <section className="mt-12 w-full  mx-auto">
                    {/* Heading */}
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">
                        Discover Our Services
                    </h2>

                    {/* Service List */}
                    <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                        {services.map((service, index) => (
                            <div key={index} className="border-b border-gray-800">
                                {/* Service Title */}
                                <button
                                    className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                >
                                    {service.title}
                                    {openIndex === index ? (
                                        <FaMinus className="text-red-500" />
                                    ) : (
                                        <FaPlus className="text-gray-600" />
                                    )}
                                </button>

                                {/* Service Description (Expandable with Animation) */}
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

export default SpecializedCare;
